import React, { Component } from 'react';
import Context from '../../contexts/MarketPerformanceContext';
import {VoidState} from "../../utilities/VoidState";

class MarketGroupsError extends Component {
    render()
    {
        return (
            <Context.Consumer>
                {(context) => (
                    <VoidState message={context.state.error.message} />
                )}
            </Context.Consumer>
        );
    }
}

export default MarketGroupsError;
